export default __webpack_public_path__ + "static/media/19-BMS.ad8aef20.png";